<body>
  <a href="javascript:" id="return-to-top"
    ><img
      src="https://img.icons8.com/metro/26/ffffff/sort-up.png"
      class="top"
      alt="sort-up"
  /></a>
  <div class="social-img">
    <a
      href="https://onpassive.com/blog"
      target="_blank"
      rel="noopener"
      title="ONPASSIVE Blog"
    >
      <img
        src="{{ onPassiveBaseUrl }}onpassive(jan-10)/assets/image/icon/blog.png"
        class="blogicon"
        alt="blog"
      />
    </a>
    <div class="long"></div>
    <a
      href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
      target="_blank"
      rel="noopener"
      title="Facebook"
    >
      <img
        src="{{ onPassiveBaseUrl }}onpassive(jan-10)/assets/image/icon/fb.png"
        class="icon"
        alt="Facebook"
      />
    </a>
    <a
      href="https://twitter.com/ONPASSIVE"
      target="_blank"
      rel="noopener"
      title="Twitter"
    >
      <img
        src="{{
          onPassiveBaseUrl
        }}onpassive(jan-10)/assets/image/icon/twitter.png"
        class="icon"
        alt="Twitter"
      />
    </a>
    <a
      href="https://www.instagram.com/ONPASSIVE/"
      target="_blank"
      rel="noopener"
      title="Instagram"
    >
      <img
        src="{{
          onPassiveBaseUrl
        }}onpassive(jan-10)/assets/image/icon/insta.png"
        class="icon"
        alt="Instagram"
      />
    </a>
    <a
      href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
      target="_blank"
      rel="noopener"
      title="Youtube"
    >
      <img
        src="{{
          onPassiveBaseUrl
        }}onpassive(jan-10)/assets/image/icon/youtube.png"
        class="icon"
        alt="YouTube"
      />
    </a>
    <a
      href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
      target="_blank"
      rel="noopener"
      title="LinkedIn"
    >
      <img
        src="{{ onPassiveBaseUrl }}onpassive(jan-10)/assets/image/icon/in.png"
        class="icon"
        alt="LinkedIn"
      />
    </a>
    <a href="#section2"
      ><img
        src="{{
          onPassiveBaseUrl
        }}onpassive(jan-10)/assets/image/icon/arrow.png"
        class="icon"
        alt="arrow"
    /></a>
  </div>
  <div class="rain front-row"></div>
  <div class="rain back-row"></div>
  <div class="container-fluid section-second">
    <div class="row justify-content-center">
      <div class="col-lg-3 text-left">
        <div class="logo mt-3">
          <img
            src="{{ onPassiveBaseUrl }}onpassive(jan-10)/assets/image/logo.png"
            alt="logo"
          />
        </div>
      </div>
      <div class="col-lg-7 text-right"></div>
    </div>
    <div class="row">
      <div class="col-lg-7">
        <div class="first">
          <span class="blink"
            ><img
              src="{{
                onPassiveBaseUrl
              }}onpassive(jan-10)/assets/image/light.png"
              alt="light"
          /></span>
        </div>
      </div>
      <div class="col-lg-3">
        <h1 class="font2 lightone">LAUNCHING</h1>
        <h2 class="font3 lightone">SOON</h2>
        <span class="blink1"
          ><img
            src="{{
              onPassiveBaseUrl
            }}onpassive(jan-10)/assets/image/light1.png"
            alt="light1"
        /></span>
      </div>
    </div>
  </div>
  <div class="main" id="section2">
    <div class="container-fluid section-third mt-5">
      <div class="row justify-content-center">
        <div class="col-lg-10 text-center">
          <h1 class="ml14">
            <span class="text-wrapper">
              <span class="letters"
                >Let ONPASSIVE Be Your Ticket To The Future.</span
              >
              <span class="line"></span>
            </span>
          </h1>
          <div class="row my-5">
            <div class="col-lg-7">
              <div class="video-box">
                <video
                  id="my-video"
                  class="
                    video-js video-size
                    w-100
                    h-auto
                    my-video-dimensions
                    shadow
                  "
                  controls
                  preload="auto"
                  poster="{{ myLinksS3URL }}images/Image0231.png"
                  data-setup="{}"
                  autoplay="true"
                  muted
                >
                  <source
                    src="{{
                      myLinksS3URL
                    }}videos/Onpassive_launching_page_video2.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
            <div class="col-lg-5">
              <p class="font1">
                While we are busy postponing our duties and opportunities, life
                speeds by. There is nothing you can do to bring back the lost
                time. The chance to pick that life-changing opportunity is here.
                ONPASSIVE is here with phenomenal AI-powered business models
                that are designed to shape your future. We offer a path for you
                to go after what you really want in life.
              </p>
              <a
                href="/registration/user?reg={{ userId }}"
                name="regform"
                target="_blank"
                rel="noopener"
                class="button fire mt-5"
                >BECOME A FOUNDER NOW</a
              >
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="copy-right text-center">
                &copy; 2022 ONPASSIVE - All Rights Reserved
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
